import { Link } from "react-router-dom";


const AuctionCard = ({auction, className}) => {
    
    return(
        <Link to = {`/auction/${auction.name}`} 
            className={`card_animation auction_card flex flex-col items-center justify-center rounded-[10px] ${className}`}>
            <div className="image_box w-full h-full max-w-[800px] max-h-[800px] mb-3">
                <img src = {auction.image} alt = {auction.name} className = "w-full h-full object-cover image_content rounded-t-[10px]" />
            </div>

            <div className="flex flex-col w-full">
                <div className="flex justify-between items-center mb-3 pb-2 border-b-[1px] border-gray-600">
                    <h3 className="text-center text-base">{auction.name}</h3>  
                    <p className="text-center text-base">{auction.price}</p>    
                </div>
                <div className="flex justify-between items-center">
                    <p className="text-center text-sm sm:text-base text-[#BCBCBC]">Ends in <span className="text-[#DE00FF]">{auction.time}</span></p>  
                    <button className="text-center text-sm sm:text-base text-[#BCBCBC] border-[#BCBCBC] border-[1px] rounded-[8px] px-4">
                        Bid    
                    </button>    
                </div>
            </div>
            

        </Link>
    )
}

export default AuctionCard;